module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/ng-image__5-a4f61207eef0068f7c853415b5a5583e.png";